export default __webpack_public_path__ + "aad1e627e844c16d99fc949fb2c70011.jpg";